module.exports = __webpack_public_path__ + "static/media/10.6eb3f946.jpg";